<input
  type="text"
  mwlFlatpickr
  [(ngModel)]="model"
  (ngModelChange)="onChange($event)"
  (flatpickrReady)="onReady($event)"
  [dateFormat]="dateFormat"
  [altInput]="true"
  [altFormat]="altFormat"
  [convertModelValue]="true"
  [disabled]="disabled"
  [minDate]="$any(minDate)"
  [maxDate]="$any(maxDate)"
  [enableTime]="enableTime"
  [time24hr]="time24hr"
  [minuteIncrement]="minuteIncrement"
  [static]="false"
  [appendTo]="calendarAppendTo"
  [disableMobile]="true"
  [placeholder]="placeholder"
  [attr.aria-label]="placeholder" />